import { wordService } from "../services/wordService";

export const applySubsection = () =>
  wordService.applySemanticTag({ type: "section", styleBuiltIn: "Heading2", metadata: { level: 2 } });
